import { CalculatedPeriod } from "../CalculatedPeriod";

export class PeriodViewDataModel{
    priceMainClass: string;
    period: CalculatedPeriod;
    statusClass: string;
    rightDashCss: string;

    constructor(source: PeriodViewDataModel) {
        this.priceMainClass = source.priceMainClass;
        this.period = source.period;
        this.statusClass = source.statusClass;
        this.rightDashCss = source.rightDashCss;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/ViewModel/PeriodViewDataModel/PeriodViewDataModel.ts